<template>
  <ok-modal
    :value="value"
    size="lg"
    dialog-class="tables-modal"
    :title="$t('invoice.invoices',{page:page.name})"
    @change="$emit('input',false)"
  >
    <div>
      <b-table
        striped
        bordered
        :responsive="true"
        :fields="fields"
        :items="invoices"
        :show-sort-icons="true"
      >
        <template
          v-if="!isReferral"
          #cell(paid)="data"
        >
          <b-form-select
            :value="data.item.paid"
            :options="invoiceStatus"
            @change="statusChanged($event, data.item.id)"
          />
        </template>
        <template
          v-else
          #cell(paid)="data"
        >
          <b-badge
            :variant="data.item.paid?'success':'danger'"
          >
            {{ $t(`${data.item.paid?'genral.yes':'general.no'}`) }}
          </b-badge>
        </template>
      </b-table>
    </div>

    <template #actions>
      <div class="d-flex justify-content-end align-items-center">
        <b-button
          variant="dark"
          @click="$emit('input',false)"
        >
          {{ $t('forms.ok') }}
        </b-button>
      </div>
    </template>
  </ok-modal>
</template>

<script>
import {
  BButton, BTable, BFormSelect, BBadge,
} from 'bootstrap-vue'
import OkModal from '@/@bya3/components/modals/OkModal'
import SubscriptionApi from '@/api/subscription'

export default {
  name: 'InvoicesModal',
  components: {
    OkModal, BButton, BTable, BFormSelect, BBadge,
  },
  props: {
    page: {
      type: Object,
      default: () => {},
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: [
        { key: 'subscribed_at', label: this.$t('invoice.subscribed-at') },
        { key: 'expires_at', label: this.$t('invoice.expires-at') },
        { key: 'paid', label: this.$t('invoice.paid') },
        { key: 'bya3com', label: 'صافي بياع كوم', sortable: true },
        { key: 'period', label: this.$t('invoice.period'), sortable: true },
      ],
      invoiceStatus: [
        { text: this.$t('general.no'), value: 0 },
        { text: this.$t('general.yes'), value: 1 },
      ],
    }
  },
  computed: {
    isReferral() {
      return this.$store.getters['auth/isReferral']
    },
    invoices() {
      return (this.page?.invoices ?? []).reverse()
    },
  },
  methods: {
    statusChanged(e, id) {
      const data = {
        paid: e,
      }
      return SubscriptionApi.updateInvoice(id, data)
        .then(() => {
          this.$notifySuccess('تم تحديث الفاتورة بنجاح')
        })
        .catch(error => this.$swalError(error))
    },
  },
}
</script>
